
<div v-if="quote && quote.items && quote.items.length > 0" class="summary-wrapper checkout-form">
  <div v-if="!hideTitle" class="is-flex is-justify-content-space-between is-align-items-center mb-4">
    <p class="summary-main-title">Summary</p>
    <!--<button v-if="showPrice" @click="generatePdf(quote)" class="button download-pdf-button is-flex"><span class="mr-2">Download</span> <icon type="pdf" /></button>-->
  </div>

  <ul class="order-summary-list-items">
    <p class="item-title mt-2 px-2">CONTAINER{{ containers.length > 1 ? 'S' : '' }}</p>
    <li v-for="item in containers" :key="item.id" class="order-summary-item">        
      <div class="row flex-on-mobile vertical-align-middle row-flex-start-item-max-width is-relative">
        <div class="is-flex row is-3 p-0">
          <a class="remove-icon" @click="removeItem(item.id)">
            <icon type="remove-item-button" />
          </a>
          <figure v-if="item.priceBookEntry.product.primaryPhoto" class="summary-image flex items-center justify-center">
            <img :src="imageUrl(item.priceBookEntry.product.primaryPhoto.key, { resize: { width: 180, height: 130 } } )">
          </figure>
          <div class="item item-8 item-conditional__to-8-on-desktop item-conditional__to-7-on-mobile">
            <div class="order-summary-item-title">
              <span class="product-title">{{ item.priceBookEntry.product.name }}</span>
            </div>
          </div>
        </div>
        <div class="flex items-center">
          <div :class="`order-item-quantities flex items-center justify-center ${showPrice ? 'mr-4' : 'mr-0'}`">
            <p>{{ item.quantity }}</p>
          </div>
          <span v-if="showPrice" class="order-item-quantities-text">{{ item.priceCents | dollars }}</span>
        </div>  
      </div>
    </li>
    <p class="item-title mt-2 px-2">DELIVERY</p>
    <li v-for="item in deliveries" :key="item.id" class="order-summary-item">        
      <div class="row neutral-gray flex-on-mobile vertical-align-middle row-flex-space-between is-relative">
        <div>
          <div class="is-3 p-0">
            <figure v-if="item.priceBookEntry.product.primaryPhoto" class="summary-image">
              <img :src="imageUrl(item.priceBookEntry.product.primaryPhoto.key, { resize: { width: 180, height: 130 } } )">
            </figure>
          </div>
          <div class="item item-8 item-conditional__to-8-on-desktop item-conditional__to-7-on-mobile">
            <div class="order-summary-item-title item-delivery-row">
              <span class="product-title">{{ item.priceBookEntry.product.name }}</span>
            </div>
          </div>
        </div>

        <div class="flex items-center">
          <span :class="`order-item-quantities flex items-center justify-center ${showPrice ? 'mr-4' : 'mr-0'}`">
            <p>{{ item.quantity }}</p>
          </span>
          <span v-if="showPrice" class="order-item-quantities-text">{{ item.priceCents | dollars }}</span>
        </div>
      </div>
    </li>
  </ul>
</div>
